import { createSelector } from 'reselect'
import { isEmpty } from 'lodash'

const selectorFactory = (countrySelector, loadedSelector) =>
  createSelector(countrySelector, loadedSelector, (country, loaded) =>
    loaded ? isEmpty(country) || !country?.isSupported : false
  )

const isUnsupportedInJurisdictionSelectorDefinition = {
  id: 'isUnsupportedInJurisdiction',
  selectorFactory,
  dependencies: [
    //
    { selector: 'country' },
    { selector: 'loaded' },
  ],
}

export default isUnsupportedInJurisdictionSelectorDefinition
